const createMinisiteUrl = (timeId, config) => {
  const regex = /(https?:\/\/)/;
  const timeIdUrl = config.minisiteURL.replace(regex, `$1${timeId}.`);
  return timeIdUrl;
};

const getLoginURL = (event, config, target, redirectId) => {
  let actualTarget = target;
  if (redirectId && actualTarget) {
    return `${config.login_url}?${actualTarget}&r_id=${redirectId}`;
  }
  if (!actualTarget) {
    actualTarget = document.location.href;
  } else if (event && event.actualTarget.getElementsByTagName("a")[0]) {
    const href = event.actualTarget.getElementsByTagName("a")[0].getAttribute("href");
    if (href.indexOf("http:") === 0) {
      actualTarget = href;
    } else {
      actualTarget = `${document.location.protocol}://${document.location.host}${href}`;
    }
  }
  if (actualTarget) {
    actualTarget = encodeURIComponent(actualTarget);
    return `${config.login_url}?force_return=true&url=${actualTarget}`;
  }
  return "";
};

const redirectToLogin = (event, config, target, redirectId) => {
  const url = getLoginURL(event, config, target, redirectId);
  if (url) document.location = url;
  return true;
};

const redirectToLogout = (config, target) => {
  document.location = `${config.logout_url}?force_return=true&url=${encodeURIComponent(target)}`;
};

export default {
  createMinisiteUrl,
  getLoginURL,
  redirectToLogin,
  redirectToLogout,
};
